import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, ChevronRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const OrganizationSelector = () => {
  const { organizations, selectOrganization, user } = useAuth();
  const navigate = useNavigate();

  const handleSelectOrg = (org) => {
    selectOrganization(org);
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="flex justify-center">
            <img src="/logo.png" alt="Innings Pro" className="h-24 w-48" />
          </div>
          <h2 className="mt-4 text-2xl md:text-3xl font-extrabold text-gray-900">
            Select Organization
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Welcome, {user?.full_name || user?.username}! Choose an organization to continue.
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {organizations.length === 0 ? (
            <div className="bg-yellow-50 border border-yellow-200 text-yellow-700 px-4 py-3 rounded text-center">
              <p>You don't have access to any organizations yet.</p>
              <p className="text-sm mt-2">Please contact an administrator to get access.</p>
            </div>
          ) : (
            organizations.map((org) => (
              <button
                key={org.id}
                onClick={() => handleSelectOrg(org)}
                className="w-full flex items-center justify-between px-4 py-4 border border-gray-300 rounded-lg hover:border-green-500 hover:bg-green-50 transition-colors group"
              >
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-lg bg-green-100 text-green-600 flex items-center justify-center">
                    {org.logo_url ? (
                      <img src={org.logo_url} alt={org.name} className="w-8 h-8 rounded" />
                    ) : (
                      <Building2 className="h-5 w-5" />
                    )}
                  </div>
                  <div className="text-left">
                    <p className="text-sm font-medium text-gray-900">{org.name}</p>
                    <p className="text-xs text-gray-500">{org.role === 'owner' ? 'Owner' : 'Member'}</p>
                  </div>
                </div>
                <ChevronRight className="h-5 w-5 text-gray-400 group-hover:text-green-500" />
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default OrganizationSelector;
